export default __webpack_public_path__ + "static/media/2.34144839.png";